import { GeoListingsFilters, LISTINGS_POLYGON_API, LatitudeLongitude } from '@aloft/toolkit-shared';

import { useGetListingsByPolygon } from '../../../hooks/api/toolkitComponents.ts';

export async function getListingsByPolygon({
  getListings,
  body,
}: {
  getListings: ReturnType<typeof useGetListingsByPolygon>;
  body: {
    coordinates: LatitudeLongitude[];
    filters?: GeoListingsFilters;
  };
}) {
  const validatedReq = LISTINGS_POLYGON_API.POST.REQUEST.BODY.parse(body);
  const res = await getListings.mutateAsync({
    body: validatedReq,
  });
  const validatedRes = LISTINGS_POLYGON_API.POST.RESPONSE.parse(res);
  return validatedRes;
}
